import React from "react"
import styled from "styled-components"

export const FocusableDiv = styled.div.attrs((props) => ({
  ...props,
  tabIndex: 0,
}))``
